import { render } from "./CellComponent.vue?vue&type=template&id=422c655a"
import script from "./CellComponent.vue?vue&type=script&lang=js"
export * from "./CellComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__